import { render, staticRenderFns } from "./FooterHomeJournal.vue?vue&type=template&id=bce3c0ce"
import script from "./FooterHomeJournal.vue?vue&type=script&lang=js"
export * from "./FooterHomeJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports